import DashboardTemplate from './DashboardTemplate';
import { Users } from 'lucide-react';

const PeopleDashboard = () => {
  return (
    <DashboardTemplate
      functionType="people"
      title="People"
      subtitle="Headcount, Attrition, Time to Fill & eNPS"
      icon={Users}
    />
  );
};

export default PeopleDashboard;
